import { Col, Row, Space } from 'antd';
import React from 'react';
import RightContent from './RightContent';
// import ReturnInformation from './ReturnInformation';
import ProductCard from './ProductCard';

const TransferForm = ({ isEdit }: { isEdit?: boolean }) => {
  return (
    <div className="mt-5">
      <Row gutter={[20, 20]}>
        <Col lg={16} md={24} xs={24}>
          <Space className="w-full" size={20} direction="vertical">
            <ProductCard isEdit={isEdit} />
            {/* <ReturnInformation /> */}
          </Space>
        </Col>
        <Col lg={8} md={24} xs={24}>
          <RightContent isEdit={isEdit} />
        </Col>
      </Row>
    </div>
  );
};

export default TransferForm;
